export default __webpack_public_path__ + "static/media/title2.378221dc.png";